/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiologyPricing from './radiology-pricing';
import RadiologyPricingDetail from './radiology-pricing-detail';
import RadiologyPricingUpdate from './radiology-pricing-update';
import RadiologyPricingDeleteDialog from './radiology-pricing-delete-dialog';

const RadiologyPricingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiologyPricing />} />
    <Route path="new" element={<RadiologyPricingUpdate />} />
    <Route path=":id">
      <Route index element={<RadiologyPricingDetail />} />
      <Route path="edit" element={<RadiologyPricingUpdate />} />
      <Route path="delete" element={<RadiologyPricingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiologyPricingRoutes;
